<template>
  <span class="inline">
    <tooltip v-if="showTooltip">
      <span
        data-node-content
        data-cy="formula-function"
        class="font-semibold text-primary uppercase"
      >
        {{ node.content }}
      </span>
      <template #content>
        <span>{{ explanation }}</span>
      </template>
    </tooltip>
    <span
      v-else
      data-node-content
      data-cy="formula-function"
      class="font-semibold text-primary uppercase"
    >
      {{ node.content }}
    </span>
  </span>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";

import type { EditorNode } from "@/models/TextEditor";
import type { FormulaOption } from "@/models/options";

const { node } = defineProps<{
  node: EditorNode;
}>();

const { getters } = useStore();
const { t } = useI18n();

const functionLookupMap = computed(
  () => getters["options/attributeFunctionsLookupMap"]
);

const functionOption = computed<FormulaOption | undefined>(() =>
  functionLookupMap.value.get(node.content.toLowerCase())
);

const explanation = computed(() => {
  return functionOption.value?.usage
    ? `${t("COMMON.USAGE")}: '${functionOption.value.usage}'`
    : "";
});

const showTooltip = computed(() => !node.error?.message && !!explanation.value);
</script>
